import { z } from "zod";

export const integratePersonioFormSchema = z.object({
	clientId: z.string().min(1, "Client ID is required"),
	secret: z.string().min(1, "Client Secret is required"),
	userIdentifier: z.string().min(1, "User Identifier is required"),
});

export type IntegratePersonioFormSchema = z.infer<typeof integratePersonioFormSchema>;
